<template>
  <div id="vip">
    <van-row class="vip_shop">
      <van-col span="22" offset="1">
        <van-col span="24">
          <van-col span="12" class="grade_type" @click="agent_href()">{{ $t('column.agent_title')}}</van-col>
          <van-col span="12" class="grade_type grade_chencked">{{ $t('column.vip_title')}}</van-col>
          <van-col span="2" offset="17" class="grade_chencked_vip"></van-col>
        </van-col>
        <van-col span="24" class="vip_grade_bg">
          <div class="vip_grade_img">
            <van-image round width="4.5em" height="4.5em" :src="user.head_image" />
          </div>
          <van-col span="24" v-if="is_vip">
            <van-col span="24" class="vip_grade_title">{{ user.name }}</van-col>
            <van-col span="15" offset="2" class="vip_grade_progress">
              <van-progress :percentage="user.num_proportion" pivot-text="" color="#f1cd7c" track-color="#8e8a8a"/>
            </van-col>
            <van-col span="6" class="vip_grade_progress_sum">{{ user.vip_coin }}/{{ user.max_num }}</van-col>
            <van-col span="24" class="vip_grade_center">{{ $t('column.Recapture')}}{{ user.num_surplus }}{{ $t('column.Growth_value_can_upgraded_to')}}{{ user.next_name }}</van-col>
          </van-col>
          <van-col span="24" v-else>
            <van-col span="24" class="vip_grade_no_vip">{{ $t('column.Not_VIP_at_present')}}</van-col>
            <van-col span="24" class="vip_grade_no_vip_center">{{ $t('column.Complete_any_condition_upgrade')}}</van-col>
          </van-col>
        </van-col>
        <van-col span="24" v-if="is_vip">
          <van-col span="24" class="vip_grade_task">
            <van-col span="12" class="vip_grade_task_title">{{ $t('column.How_to_upgrade_quickly')}}</van-col>
            <van-col span="11" class="vip_grade_task_center" @click="vip_task_href()">{{ $t('column.View_upgrade_tasks')}}</van-col>
            <van-col span="1" class="vip_grade_task_jian" @click="vip_task_href()"><van-icon name="arrow"/></van-col>
          </van-col>
          <van-col span="24" class="vip_grade_privilege_title">{{ $t('column.Membership_privileges')}}</van-col>
          <van-col span="24" class="vip_grade_type">
            <van-tabs>
              <van-tab v-for="(v,k) in vip_list" :key="k"  :title="v.name" class="vip_grade_type_list">
                <van-col span="6" v-for="(p,k) in v.privilege"   :key="k"  class="vip_grade_privilege_type">
                  <van-col span="24" v-if="p.ischecked">
                    <van-col span="24">
                      <van-image width="50" :src="p.img" />
                    </van-col>
                    <van-col span="24" class="vip_grade_privilege_type_title">{{ p.title }}</van-col>
                  </van-col>
                  <van-col span="24" v-else>
                    <van-col span="24">
                      <van-image width="50" :src="p.img2" />
                    </van-col>
                    <van-col span="24" class="vip_grade_privilege_type_title2">{{ p.title }}</van-col>
                  </van-col>
                </van-col>
                <div class="vip_bottom"></div>
              </van-tab>

            </van-tabs>
          </van-col>
        </van-col>
        <van-col span="24" v-else>
          <van-col span="24" class="vip_grade_condition_title">{{ $t('column.Upgrade_conditions')}}</van-col>
          <van-col span="24" v-for="(l,i) in vip_condition" :key="l.id" class="vip_grade_condition_type">
            {{ i + 1 }}、{{ l.title }}  ( {{l.complete}} / {{ l.sum }} )
          </van-col>
        </van-col>

      </van-col>
    </van-row>
  </div>
</template>

<script>

  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Dialog, Progress, Tab, Tabs } from 'vant'
  export default {
    data() {
      return {
        active: 2,
        is_vip: false,
        vip_condition: [],
        vip_list:[],
        user:{}
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.agent')
    },
    components: {
      [Dialog.name]: Dialog,
      [Progress.name]: Progress
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vip_grade&act=index", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)

          this.vip_list = res.data.data.vip_list
          this.is_vip = res.data.data.is_vip
          if(this.is_vip === 0){
            this.vip_condition = res.data.data.vip_condition
          }
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }else{
            this.user = res.data.data.user
          }
        })
      },
      vip_task_href() {
        const token = this.$route.query.token
        this.$router.push({path: '/vip_task', query: {token: token}});
      },
      agent_href() {
        const token = this.$route.query.token
        this.$router.push({path: '/agent', query: {token: token}});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vip_grade.vue